export enum LocalStorageKeys {
  NavbarCollapsed = "noan-navbar-collapsed",
  FirstSessionLogin = "noan-first-session-login",
  FirstBlockCompleted = "noan-first-block-completed",
  FirstUseBlockNav = "noan-first-use-block-nav",
  UICollapsible = "noan-ui-collapsible",
  ShowHiddenChatThreads = "noan-show-hidden-chat-threads",
  OnboardingVideoSeen = "noan-onboarding-video-seen",
  TrackingParams = "noan-tracking-params",
  ReturnTo = "noan-return-to",
  VoiceWaitlistJoined = "noan-voice-waitlist-joined",
  ShowDoneTaskColumn = "noan-show-done-task-column",
}
